import { z } from 'zod';

export const CriarObrigacaoLegalZodSchema = (menuSelecionado: 'datasFixas' | 'calculoPeriodicidade') =>
	z
		.object({
			datas: z.string().optional().nullable(),
			dataVencimento: z.string().optional().nullable(),
			periodicidade: z.number().optional().nullable(),
			descricao: z.string().min(1, 'Campo de descrição é obrigatório'),
			fundamentacaoLegal: z.string().optional(),
			prazoLegal: z.string().optional(),
			temporalidade: z.string().optional(),
			formaCumprimento: z.string().optional(),
			ano: z.string(),
		})
		.superRefine((data, ctx) => {
			if (menuSelecionado === 'datasFixas' && !data.datas) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: 'Campo de datas fixas é obrigatório',
					path: ['datas'],
				});
			}

			if (menuSelecionado === 'calculoPeriodicidade') {
				if (!data.dataVencimento) {
					ctx.addIssue({
						code: z.ZodIssueCode.custom,
						message: 'Campo de data de vencimento é obrigatório',
						path: ['dataVencimento'],
					});
				}
				if (data.periodicidade === null) {
					ctx.addIssue({
						code: z.ZodIssueCode.custom,
						message: 'Campo de periodicidade é obrigatório',
						path: ['periodicidade'],
					});
				}
			}
		});

export type CriarObrigacaoLegalFormSchema = ReturnType<typeof CriarObrigacaoLegalZodSchema>['_type'];
